import request from '@/utils/request'

export const getSearchProductList = (data)=>{
  return request({
    url: `/api/product/search`,
    data,
    method: "post"
  });
}

// 产品列表
export const getProductList = (params)=>{
  return request({
    url: `/api/product/page`,
    params,
    method: "get"
  });
}

// 产品详情
export const getProductDetail = (params)=>{
  return request({
    url: `/api/product/id=${params.id}`,
    params,
    method: "get"
  });
}

// 点赞产品 == 无此功能
// export const fabulousProduct = (params)=>{
//   return request({
//     url: `/api/action/actionType=p-fabulous/id=${params.id}`,
//     params,
//     method: "get"
//   });
// }


// 评论列表
export const getCommentList = (params)=>{
  return request({
    url: `/api/action/comment-list/product-id=${params.id}`,
    params,
    method: "get"
  });
}




// WEBPACK FOOTER //
// ./src/api/product.js